import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavLeadRouter = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#FF4F00"
      d="M6 15v6H4v-8h7v-2.126A4.002 4.002 0 0 1 12 3a4 4 0 0 1 1 7.874V13h7v2H6Zm8-8a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm-3 14v-4h2v4h-2Zm7 0v-4h2v4h-2Z"
    />
  </svg>
);
export default SvgNavLeadRouter;
